const C = {
  name: "Image",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5 6C12.567 6 11 7.567 11 9.5C11 11.433 12.567 13 14.5 13C16.433 13 18 11.433 18 9.5C18 7.567 16.433 6 14.5 6ZM13 9.5C13 8.67157 13.6716 8 14.5 8C15.3284 8 16 8.67157 16 9.5C16 10.3284 15.3284 11 14.5 11C13.6716 11 13 10.3284 13 9.5Z" fill="currentColor"/>
<path d="M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5ZM5 4C4.44772 4 4 4.44772 4 5V12.5859L7.00008 9.58582L17.4143 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5ZM4 19C4 19.5523 4.44772 20 5 20H14.5858L7.00008 12.4142L4 15.4143V19Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Image
};
